import UserDevice from '@nollaSdk/models/UserDevice'
import { ADD_ITEM_TO_LIST, SET_ITEM, ADD_LIST } from '../core/mutation-types'
import mutations from '../core/mutations'

const state = {
  initialState() {
    return {
      list: [],
      item: null,
    }
  },
  list: [],
  item: null,
}

// actions
const actions = {
  post({ commit }, params) {
    return UserDevice.post(params)
      .then(model => {
        commit(SET_ITEM, model)
        if (model) {
          commit(ADD_ITEM_TO_LIST, model)
        }
        return model
      })
  },
  get({ commit }, id) {
    return UserDevice.find(id)
      .then(model => {
        commit(SET_ITEM, model)
        if (model) {
          commit(ADD_ITEM_TO_LIST, model)
        }
        return model
      })
  },
  getList({ commit }, params) {
    return UserDevice.search(params)
      .then(models => {
        commit(ADD_LIST, models)
        return models
      })
  },
  put({ commit }, payload) {
    return UserDevice.putSetDefault(payload.id, payload.params)
      .then(model => {
        commit(SET_ITEM, model)
        if (model) {
          commit(ADD_ITEM_TO_LIST, model)
        }
        return model
      })
  },
}

export default {
  actions,
  mutations,
  namespaced: true,
  state,
}
